"use client";

import { useEffect, useState } from "react";
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const isDarkMode = document.documentElement.classList.contains("dark");
    setIsDark(isDarkMode);
  }, []);

  const toggleTheme = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);

    if (newIsDark) {
      document.documentElement.classList.add("dark");
      localStorage.theme = "dark";
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.theme = "light";
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className={`
        px-3 py-1 rounded-full text-sm
        ${
          isDark
            ? "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100"
            : "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100"
        }
      `}
    >
      <span className="flex items-center gap-2">
        {isDark ? (
          <>
            <MoonIcon className="w-4 h-4" />
            Dark
          </>
        ) : (
          <>
            <SunIcon className="w-4 h-4" />
            Light
          </>
        )}
      </span>
    </button>
  );
}
